__turbopack_context__.v({
  "bgGradient": "SecSamplePreview-module-scss-module__vAq6YW__bgGradient",
  "bgWrap": "SecSamplePreview-module-scss-module__vAq6YW__bgWrap",
  "detailDarken": "SecSamplePreview-module-scss-module__vAq6YW__detailDarken",
  "detailDesktopCta": "SecSamplePreview-module-scss-module__vAq6YW__detailDesktopCta",
  "detailDesktopCtaHolder": "SecSamplePreview-module-scss-module__vAq6YW__detailDesktopCtaHolder",
  "detailDesktopCtaHolderSettled": "SecSamplePreview-module-scss-module__vAq6YW__detailDesktopCtaHolderSettled",
  "detailDesktopCtaHolderVisible": "SecSamplePreview-module-scss-module__vAq6YW__detailDesktopCtaHolderVisible",
  "detailDesktopCtaVisible": "SecSamplePreview-module-scss-module__vAq6YW__detailDesktopCtaVisible",
  "detailImage": "SecSamplePreview-module-scss-module__vAq6YW__detailImage",
  "detailImageInner": "SecSamplePreview-module-scss-module__vAq6YW__detailImageInner",
  "detailImageWrap": "SecSamplePreview-module-scss-module__vAq6YW__detailImageWrap",
  "detailMain": "SecSamplePreview-module-scss-module__vAq6YW__detailMain",
  "detailMainSettled": "SecSamplePreview-module-scss-module__vAq6YW__detailMainSettled",
  "detailMainVisible": "SecSamplePreview-module-scss-module__vAq6YW__detailMainVisible",
  "detailMobileCta": "SecSamplePreview-module-scss-module__vAq6YW__detailMobileCta",
  "detailMobileCtaSettled": "SecSamplePreview-module-scss-module__vAq6YW__detailMobileCtaSettled",
  "detailMobileCtaVisible": "SecSamplePreview-module-scss-module__vAq6YW__detailMobileCtaVisible",
  "detailScroll": "SecSamplePreview-module-scss-module__vAq6YW__detailScroll",
  "detailScrollSettled": "SecSamplePreview-module-scss-module__vAq6YW__detailScrollSettled",
  "detailScrollVisible": "SecSamplePreview-module-scss-module__vAq6YW__detailScrollVisible",
  "enter": "SecSamplePreview-module-scss-module__vAq6YW__enter",
  "exit": "SecSamplePreview-module-scss-module__vAq6YW__exit",
  "fade-in": "SecSamplePreview-module-scss-module__vAq6YW__fade-in",
  "fade-out": "SecSamplePreview-module-scss-module__vAq6YW__fade-out",
  "fade-out-80": "SecSamplePreview-module-scss-module__vAq6YW__fade-out-80",
  "header": "SecSamplePreview-module-scss-module__vAq6YW__header",
  "inner": "SecSamplePreview-module-scss-module__vAq6YW__inner",
  "overlayBody": "SecSamplePreview-module-scss-module__vAq6YW__overlayBody",
  "overlayBodySettled": "SecSamplePreview-module-scss-module__vAq6YW__overlayBodySettled",
  "overlayBodyVisible": "SecSamplePreview-module-scss-module__vAq6YW__overlayBodyVisible",
  "overlayCarousel": "SecSamplePreview-module-scss-module__vAq6YW__overlayCarousel",
  "overlayCloseButton": "SecSamplePreview-module-scss-module__vAq6YW__overlayCloseButton",
  "overlayCloseButtonDetail": "SecSamplePreview-module-scss-module__vAq6YW__overlayCloseButtonDetail",
  "overlayControls": "SecSamplePreview-module-scss-module__vAq6YW__overlayControls",
  "overlayHeader": "SecSamplePreview-module-scss-module__vAq6YW__overlayHeader",
  "overlayRoot": "SecSamplePreview-module-scss-module__vAq6YW__overlayRoot",
  "overlayRootVisible": "SecSamplePreview-module-scss-module__vAq6YW__overlayRootVisible",
  "overlayTitle": "SecSamplePreview-module-scss-module__vAq6YW__overlayTitle",
  "pulseGlow": "SecSamplePreview-module-scss-module__vAq6YW__pulseGlow",
  "section": "SecSamplePreview-module-scss-module__vAq6YW__section",
  "slide-in-from-bottom": "SecSamplePreview-module-scss-module__vAq6YW__slide-in-from-bottom",
  "slide-in-from-left": "SecSamplePreview-module-scss-module__vAq6YW__slide-in-from-left",
  "slide-in-from-right": "SecSamplePreview-module-scss-module__vAq6YW__slide-in-from-right",
  "slide-in-from-top": "SecSamplePreview-module-scss-module__vAq6YW__slide-in-from-top",
  "slide-out-to-bottom": "SecSamplePreview-module-scss-module__vAq6YW__slide-out-to-bottom",
  "slide-out-to-left": "SecSamplePreview-module-scss-module__vAq6YW__slide-out-to-left",
  "slide-out-to-right": "SecSamplePreview-module-scss-module__vAq6YW__slide-out-to-right",
  "slide-out-to-top": "SecSamplePreview-module-scss-module__vAq6YW__slide-out-to-top",
  "stackArea": "SecSamplePreview-module-scss-module__vAq6YW__stackArea",
  "stackButton": "SecSamplePreview-module-scss-module__vAq6YW__stackButton",
  "stackButtonInteractive": "SecSamplePreview-module-scss-module__vAq6YW__stackButtonInteractive",
  "stackButtonStatic": "SecSamplePreview-module-scss-module__vAq6YW__stackButtonStatic",
  "stackCard": "SecSamplePreview-module-scss-module__vAq6YW__stackCard",
  "stackCardImage": "SecSamplePreview-module-scss-module__vAq6YW__stackCardImage",
  "stackCardInner": "SecSamplePreview-module-scss-module__vAq6YW__stackCardInner",
  "stackCardOverlay": "SecSamplePreview-module-scss-module__vAq6YW__stackCardOverlay",
  "stackContainer": "SecSamplePreview-module-scss-module__vAq6YW__stackContainer",
  "stackFrame": "SecSamplePreview-module-scss-module__vAq6YW__stackFrame",
  "stackWrap": "SecSamplePreview-module-scss-module__vAq6YW__stackWrap",
  "sticky": "SecSamplePreview-module-scss-module__vAq6YW__sticky",
  "stickyHidden": "SecSamplePreview-module-scss-module__vAq6YW__stickyHidden",
  "title": "SecSamplePreview-module-scss-module__vAq6YW__title",
  "zoom-in": "SecSamplePreview-module-scss-module__vAq6YW__zoom-in",
  "zoom-out": "SecSamplePreview-module-scss-module__vAq6YW__zoom-out",
});
